import React, { useRef, useState } from 'react';
import {useDispatch} from 'react-redux';
import CollectionCardDropDown from './CollectionCardDropDown';
import CollectionModal from '../Modal/CollectionModal/CollectionModal';
import ConfirmationModal from '../Modal/CollectionModal/ConfirmationModal';
import { deleteCollections } from '../../actions';
import styles from './CollectionCard.scss';
import {Link, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import ShareDropdown from '../ShareDropdown/ShareDropdown';
import {isOnMobileDevice} from '../../lib/share';

const CollectionCard = (props) => {
  const { cardImageUrl, cardName, cardCount, cardLink, collectionUuid, menuVisible = true} = props;
  const menuRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showShareDropdown, setShowShareDropdown] = useState(false);
  const dispatch = useDispatch();

  const handleRemove = () => {
    const payload = { collectionUuid };
    dispatch(deleteCollections(payload));
    setShowDeleteModal(false);
  };

  const handleShowShareDropdownChange = () => {
    if (navigator.share && isOnMobileDevice(navigator)) {
      navigator.share({
        title: cardName,
        text: 'Check out this collection on OnTheHouse: ',
        url:`https://${window.location.host}/members/collection?id=${collectionUuid}`,
      }).then(() => {});
    } else {
      setShowShareDropdown(!showShareDropdown);
    }
  };

  return (
    <div className={styles.cardContainer}>
      <Link to={cardLink}>
        <div className={styles.cardImage} style={{backgroundImage: `url('${cardImageUrl}')`}}/>

        <div className={styles.cardDetails}>
          <div className={'d-flex justify-content-between align-items-center mb-3'}>
            <h4>{cardName}</h4>
            { menuVisible && <button className={styles.cardOptionsButton} ref={menuRef} onClick={(e) => {
              e.preventDefault();
              setOpenMenu(!openMenu);
            }} /> }
          </div>
          <span>{cardCount} propert{cardCount > 1 ? 'ies' : 'y'}</span>
        </div>
      </Link>

      <CollectionCardDropDown
        ref={menuRef}
        open={openMenu}
        onCloseHandler={() => setOpenMenu(false)}
        onUpdate={() => setShowCreateModal(true)}
        onDelete={() => setShowDeleteModal(true)}
        onShare={() => handleShowShareDropdownChange()}
      />

      <CollectionModal
        showModal={showCreateModal}
        toggleModal={() => setShowCreateModal(!showCreateModal)}
        modalMode={'EDIT'}
        exitOnSave={true}
        collectionUuid={collectionUuid}
        collectionName={cardName}
      />

      <ConfirmationModal
        showModal={showDeleteModal}
        toggleModal={() => setShowDeleteModal(!showDeleteModal)}
        onConfirm={() => { handleRemove(); }}
      />

      <ShareDropdown
        pathname={cardLink}
        open={showShareDropdown}
        onCloseHandler={handleShowShareDropdownChange}
        ref={menuRef}
        isFromCollection={true}
        collectionName={cardName}
      />

    </div>
  );
};

CollectionCard.propTypes = {
  cardImageUrl: PropTypes.string,
  cardName: PropTypes.string,
  cardCount: PropTypes.number,
  cardLink: PropTypes.string,
  collectionUuid: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  menuVisible: PropTypes.bool
};

export default withRouter(CollectionCard);